// Pages a signed-in person may open before confirming their email: the
// verify page itself, pricing (public anyway), their own account settings,
// notifications and public info pages. Everything else (Drive, uploads,
// shares, workspaces, billing checkout) waits for the email to be verified.
const UNVERIFIED_ALLOWED_PATHS = [
  /^\/verify-email\/?$/,
  /^\/pricing\/?$/,
  /^\/account-settings(\/(general|appearance|security|notifications)?)?\/?$/,
  /^\/notifications\/?$/,
  /^\/(api-docs|developers)(\/|$)/,
  /^\/contact\/?$/,
  /^\/pages\//,
  /^\/(login|register|logout)(\/|$)/,
  /^\/(suspended|viewing-as\/admin-closed)\/?$/,
];

export function openBeforeEmailVerified(
  pathname: string,
  baseUri = '',
): boolean {
  const base = baseUri.replace(/\/$/, '');
  const path =
    base && pathname.startsWith(base) ? pathname.slice(base.length) : pathname;
  return UNVERIFIED_ALLOWED_PATHS.some(re => re.test(path || '/'));
}
